import React, { FunctionComponent, MouseEvent } from 'react';
import GenericTable from 'components/Table/GenericTable';
import {
  TableRowData,
  TableColumn,
  TableColumn$RenderProps,
  Button,
  Colors,
  RowActionsRender,
} from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';
import moment from 'moment';

// utils
import { convertArrayToCamelCase } from 'utils/helpers';
import { fromPairs } from 'lodash';

// components
import { SessionDetails } from 'ducks/merchantDucks/items/types';

const StyledSpan = styled.span`
  vertical-align: text-top;
`;

const LinkButton = styled(Button)`
  padding: 0;
  &:hover {
    background-color: ${Colors.white};
  }
  &:focus {
    background-color: ${Colors.white};
  }
`;

interface OwnProps {
  sessions: any;
  handleShowModal: (browserFingerprint: string) => any;
}

type Props = OwnProps;

interface SessionsTableData extends TableRowData {
  agentInfo: string;
  lastUsed: number;
  browserFingerprint: string;
  code: string;
  id: number;
}

const SessionsTable: FunctionComponent<Props> = ({ sessions: { collection, isFetching }, handleShowModal }) => {
  const sessionsCollection = convertArrayToCamelCase<SessionDetails, SessionsTableData>(collection);

  const formatValue = (value: string) => {
    return fromPairs(value.split(',').map((info: string) => info.trim().split(':')));
  };

  const generateColumns = (): Array<TableColumn<SessionsTableData>> => [
    {
      title: 'Device',
      key: 'agentInfo',
      render: ({ value }: TableColumn$RenderProps<SessionsTableData>) => formatValue(value).Device,
    },
    {
      title: 'Last used (UTC)',
      key: 'lastUsed',
      render: ({ value }: TableColumn$RenderProps<SessionsTableData>) =>
        moment(value * 1000)
          .utc()
          .format('YYYY/MM/DD HH:mm'),
    },
    {
      title: 'Browser',
      key: 'agentInfo',
      render: ({ value }: TableColumn$RenderProps<SessionsTableData>) => formatValue(value).Browser,
    },
    {
      title: 'OS',
      key: 'agentInfo',
      render: ({ value }: TableColumn$RenderProps<SessionsTableData>) => formatValue(value).OS,
    },
  ];

  const renderRowActions: RowActionsRender<SessionsTableData> = ({ row }) => {
    const showModal = (e: MouseEvent<HTMLElement>) => {
      e.preventDefault();
      handleShowModal(row.browserFingerprint);
    };

    return (
      <StyledSpan key={row.id}>
        <LinkButton buttonModifiers={['buttonLink']} type="button" onClick={showModal}>
          Terminate
        </LinkButton>
      </StyledSpan>
    );
  };

  return (
    <>
      <GenericTable<SessionsTableData>
        columns={generateColumns()}
        data={sessionsCollection}
        showLoader={isFetching}
        options={{
          rowActions: renderRowActions,
        }}
        type="active sessions"
      />
    </>
  );
};
export default SessionsTable;
